<!--
 * @Author: dee
 * @Date: 2022-04-19 16:14:06
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-04-20 17:30:39
 * @Description: file content
-->
<template>
  <div>
    <!-- <iframe class="layout" :src="'http://localhost:7456/?num='+gameCount"></iframe> -->
    <iframe v-if="isUpDate" class="layout" :src="`${src}&v=${$OSSVersion}`"></iframe>
    <!-- <div class="mask" v-show="isMask" @click="hideMask"></div> -->
    <div class="loading" v-show="isLoading"></div>
    <!-- <div class="footer" v-show="isShowGoBack" @click="back"></div> -->
    <div class="tips" v-show="isShowGoBack">点击“开始游戏”即可参与“全民云抗疫 并肩大作战”
      <br />游戏，手指在屏幕上滑动切开病毒即可获得分数奖励，
      <br />碰到防疫工具会减少分数，累计获得一千分
      <br />即可参与抽奖，赶快参与吧！</div>
    <BaseBtnHome v-show="isShowGoBack"></BaseBtnHome>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import Vue from 'vue/dist/vue.js'
export default {
  data() {
    return {
      score: -1,
      gameCount: 0,
      isLoading: true,
      isShowGoBack: true,
      loopGameloop: "",
      loopPipeloop: "",
      isUpDate: false,
      // gameCountLoading:false,
      count: 100,//多少分通关
      countdown: 30,//游戏倒计时
      src: "",
      // isMask: true,
    };
  },
  computed: {},
  methods: {
    //获取游戏次数
    async getGameCount(){
      this.$httpdf.get(this.apiHost + 'bird/gameCount', null, {res: "data",})
      .then((data) => {
        console.log('游戏次数----',data)
        if(data.code == 0){
          // if(this.gameCountLoading){
          //   this.gameCountLoading = false
          //   if(!this.isLoading){
          //     Indicator.close();
          //   }
          // }
          this.gameCount = data.data.gameCount
          this.src = this.$config.gameUrl + '?gameCount='+ this.gameCount + '&passScore=' + this.count + '&cutDown=' + this.countdown
          this.isUpDate = true
        }
      })
    },
    //获取游戏信息
    async getGameInfo(){
      this.$httpdf.get(this.apiHost + 'bird/info', null, {res: "data",})
      .then((data) => {
        console.log('游戏信息----',data)
        if(data.code == 0){
          this.count = data.data.count
          this.countdown = data.data.countdown
        }
      })
    },
    //开始游戏
    beginGame(){
      this.$httpdf.get(this.apiHost + 'bird/beginGame', null, {res: "data",})
      .then((data) => {
        console.log('开始游戏-----',data)
        if(data.code != 0){
          // let text = {
          //   text1: "啊哦，游戏",
          //   text2: "机会",
          //   text3: "已用完！戳右上角，",
          //   text4: "将金喜传播给亲友，还能获得更多游戏机会～",
          //   text5: "更多「金喜」等你来领！",
          //   text6: "",
          // };
          // this.$modal.nochance.alert(text).then((res) => {
          //   if (res == "onSave") {
          //     this.$modal.poster.alert()
          //   }
          // });
        }
      })
    },
    //游戏结束
    gameOver(score,number){
      Indicator.open({text: "",});
      this.$httpdf.get(this.apiHost + 'bird/drawGame', {count:score}, {res: "data",})
      .then((data) => {
        Indicator.close()
        console.log('游戏结束接口----',data)
        const _self = this;
        if(data.code == 0){
          if(data.data == 0 ){
            //未达到分数
            // let message = {
            //   title: "继续加油呀",
            //   info: "暂未达到目标分数，再来一次吧～<br/>还有更多奖品等您抱回家哦！",
            //   type: "gameOver",
            // };
            _self.$modal.drawForm.alert({ 
              drawTxt: 3,
              thanksTxt: '暂未达到目标分数，再来一次吧～<br/>还有更多奖品等您抱回家哦！',
              btnTxt: '呼朋唤友',
              btnStatus: 1
             }).then((res) => {
              console.log(res)
              // if (res == "gameOver") {
                
              // }
              _self.isUpDate = false
              this.isLoading = true
              // this.isMask = true
              // this.gameCountLoading = true
              Indicator.open({text: "游戏加载中...",});
              _self.getGameCount();
              let $gameTime = Vue.prototype.$gameTime || 0
              Vue.prototype.$gameTime = $gameTime + 1
            });
          } else if(data.data == 1){
            //达到分数
            let message = {
              drawTxt: 1,
              thanksTxt: `您一共消灭了${number}个病毒，<br />获得${score}分，赶快去抽奖吧！`,
              btnTxt: '去抽奖',
              btnStatus: 2,
            };
            this.$modal.drawForm.alert(message).then((data) => {
              if (data == "draw") {
                this.$goPage("blindBox");
              } else {
                _self.isUpDate = false
                this.isLoading = true
                // this.isMask = true
                _self.getGameCount();
                let $gameTime = Vue.prototype.$gameTime || 0
                Vue.prototype.$gameTime = $gameTime + 1
              }
            });
          }
        } else{
          this.$showToast({ message: data.msg,duration: 2000});
        }
      }).catch(()=>{
        Indicator.close()
      })
    },

    back() {
      this.$goPage("index");
    },
    // hideMask() {
    //   if(this.gameCount == 0) {
    //     return this.$modal.drawForm.alert({ status: 3 });
    //   }
    //   this.isMask = false;
    // },

    //监听postMessage
    postMessageData(){
      this.isLoading = true
      Indicator.open({text: "游戏加载中...",});
      window.addEventListener("message", this.handleMessage, true)
    },

    handleMessage(e) {
      console.log('postMessageData----',e.data)
      if (e.data.type !== "success") {
        Indicator.close();
        return;
      }
      
      // 游戏加载完了
      if (e.data.loading == 'true') {
        this.isLoading = false;
        Indicator.close();
      }

      // 开始游戏
      if (e.data.isStart=='true') {
        this.isShowGoBack = false;
        this.beginGame();
      }

      //没有游戏次数
      if (e.data.gameCount == 0) {
        this.$modal.drawForm.alert({ 
          btnStatus: 1,
          thanksTxt: `游戏机会用完了，推荐好友参与活动还能获得更多游戏机会～`,
          btnTxt: `呼朋唤友`
         });
        this.isShowGoBack = true;
      }
      
      // 游戏结束
      if (e.data.isOver) {
        this.isShowGoBack = true;
        let { score, number } = e.data;
        this.gameOver(score,number)
      }
    }
  },
  async created() {
     //监听postMessage 
    this.postMessageData()  
    if(!this.$infoId){
      Vue.prototype.$infoId = this.$util.cookie.get("infoId");
    }
    await this.getGameInfo();
    this.getGameCount();
    this.$wx.shareCallBackFunList.push("share1", () => {
      // this.$modal.drawForm.close();
      console.log('分享----')
      this.$httpdf.post(this.apiHost + 'share/share').then( async()=>{
        this.isLoading = true
        // this.gameCountLoading = true
        Indicator.open({text: "游戏加载中..."});
        await this.getGameCount();
        let $gameTime = Vue.prototype.$gameTime || 0
        console.log("shareGame", $gameTime)
        Vue.prototype.$gameTime = $gameTime + 1
        console.log("shareTime", Vue.prototype.$gameTime)
      })
      this.$modal.share.close();
      this.$config.openYqAnalytics && this.$biz.handlerYqAnalyticsEvent('share')
      this.$config.openSalesLeads && this.$rsh5.actShare()
    });
  },
  mounted() {
    //活动规则弹框
    // this.$modal.rule.alert()
     
  },
  watch: {},
  destroyed() {
    this.$modal.share.close();
    this.$modal.drawForm.close();
    // this.$modal.thanks.close()
    // this.$modal.rule.close()
    window.removeEventListener("message", this.handleMessage, true);
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border: 0;
  outline-width: 0;
}

.loading {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: linear-gradient(0deg, #FEE4C3 0%, #FFC365 100%);
  // background-image: url('http://assets.rurushishi.com/activies/panda-game/index-bg.png?x-oss-process=image/resize,p_70');
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}
.mask {
  width: 100%;
  height: 100vh;
  background: url($imgHost + 'mask.png?v=1') center / 298px 529px no-repeat, rgba(0, 0, 0, .85);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  @extend .flex-center-center;
  z-index: 90;
}

.tips {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #EA4814;
  line-height: 24px;
}
.footer {
  bottom: 40px;
  right: 10px;
  width: 55px;
  height: 55px;
  background: linear-gradient(180deg, rgba(28, 188, 234, 1), rgba(74, 141, 203, 1));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-align: justify;
  z-index: 2;
}

.count {
  position: fixed;
  top: 75px;
  left: 18px;
  width: 110px;
  height: 28px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  border-radius: 14px;
  color: #fff;
  font-size: 13px;
  text-align: center;
  line-height: 28px;
  font-weight: bold;
}
</style>
